var map = {
	"./pg3/Pages/RecommendationListScreen/PracticeRecommendationList": [
		219,
		0,
		6,
		10,
		74
	],
	"./purepro/Pages/RecommendationListScreen/PracticeRecommendationList": [
		220,
		0,
		2,
		3,
		6,
		23
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 158;
module.exports = webpackAsyncContext;